export const environment = {
  apiParq: 'https://api-dev.parqtech.com/api',
  clients: {
    operator: 'https://main.d3bn372mjaphb5.amplifyapp.com',
  },
  parq: {
    anprEmailPrefix: 'anpr.',
    driverId: 760,
    guestsDomain: '@guests.parqco.com',
    serviceChargePercentage: 5,
  },
  email: '@users.parqco.com',
  kushkiMerchantId: '1000000681457096980515794014113',
  microliths: {
    entities: 'https://api-dev.parqtech.com/api/entities/v2',
    fe: 'https://api-dev.parqtech.com/api/fe/v2',
    management: 'https://api-dev.parqtech.com/api/management/v2',
    payments: 'https://api-dev.parqtech.com/api/payments/v2',
    services: 'https://api-dev.parqtech.com/api/services/v2',
    users: 'https://api-dev.parqtech.com/api/users/v2',
  },
  production: false,
};
